<template>
  <div id="email">
    <loading
      :active.sync="bigLoading"
      :can-cancel="false"
      loader="dots"
      color="#007bff"
      :height="45"
      :width="75"
      :is-full-page="fullPage"
    >
    </loading>
    <form name="frm" @submit="onSubmit" enctype="multipart/form-data">
      <v-row>
        <p id="email__back" v-on:click="goBack">Go Back</p>
      </v-row>
      <v-app-bar
        color="indigo"
        style="padding: 0px"
        height="30px"
        id="email__header1"
      >
        <div id="email__header1--1"><b>ID</b></div>
        <div id="email__header1--2"><b>Status</b></div>
        <div id="email__header1--3"><b>Subject</b></div>
        <div id="email__header1--5"><b>Sender</b></div>
        <div id="email__header1--7"><b>Points</b></div>
        <div id="email__header1--8"><b>Date</b></div>
      </v-app-bar>
      <!-- <div v-if="isloading" class="loader"></div>  -->
      <div id="email__header2">
        <div id="email__header2--1">{{ muids }}</div>
        <div id="email__header2--2" v-if="deleted === 2 || deleted === 3">
          {{ current_status }}
        </div>
        <div id="email__header2--2" v-else>
          <div class="loader" v-if="update_working"></div>
          <v-select
            :items="status_without_junk"
            dense
            solo
            hide-details="true"
            class="select__item min_width_select"
            v-model="updateStatus"
            v-else
          />
          <div id="email__header2--2__done" v-if="update_done">Done</div>
        </div>
        <div id="email__header2--3">{{ subject }}</div>
        <div id="email__header2--5">
          <span v-if="panelistemail">{{ panelistemail }}</span
          ><br />
          <span v-if="panelistid">({{ panelistid }})</span><br />
          <span v-if="state"> State: {{ state }}</span>
          <span v-if="age">, Age: {{ age }}</span>
        </div>
        <div id="email__header2--7">
          <v-select :items="scores" dense solo hide-details="true" class="select__item min_width_select"
            v-model="emailPoints"></v-select>
        </div>
        <div id="email__header2--8">{{ date }}</div>
      </div>

      <!-- <Forwarded/> -->

      <v-row no-gutters>
        <v-col cols="8" style="margin-left: 5px; padding-left: 0px">
          <p id="email__back">
            <a
              @click.prevent="manageProduct"
              target="_blank"
              style="text-decoration: none; color: #00a4e4"
              >Manage Product</a
            >
          </p>
          <p id="email__back">
            <a
              @click.prevent="manageProductV2"
              target="_blank"
              style="text-decoration: none; color: #00a4e4"
              >Manage Product V2</a
            >
          </p>
          <p id="email__back">
            <a
              :href="render_url"
              target="_blank"
              style="text-decoration: none; color: #00a4e4"
              >View Orginal</a
            >
          </p>
          <p id="email__back">
            <span
              v-on:click="editOriginal()"
              style="text-decoration: none; color: #00a4e4; cursor: pointer"
              >Edit Orginal</span
            >
          </p>
          <p id="email__back">
            <span
              v-on:click="openprocesshtmlPopUp('')"
              style="text-decoration: none; color: #00a4e4; cursor: pointer"
              >View Processed Html</span
            >
          </p>
          <p id="email__back">
            <span
              v-on:click="openpdfPopUp('')"
              style="text-decoration: none; color: #00a4e4; cursor: pointer"
              >View Processed PDF</span
            >
          </p>
          <!-- <p id="email__back" v-if="status.toLowerCase() !== 'copy' && status.toLowerCase() !== 'used'">
                                <span  v-on:click="openApcPopUp('')" style="text-decoration:none;color: #00A4E4;cursor:pointer">
                                    APC PROCESS
                                </span>
                            </p> -->
          <p id="email__back" v-if="working">
            <span class="loader" style="margin: 0"></span>
          </p>
          <p id="email__back" v-if="apc_process_msg">
            <span
              v-if="apc_process_status.toLowerCase() === 'success'"
              style="color: green; font-weight: bold"
              >{{ apc_process_msg }}</span
            >
            <span v-else style="color: red; font-weight: bold">{{
              apc_process_msg
            }}</span>
          </p>
        </v-col>
      </v-row>

      <div id="email__bodyelement">
        <div v-if="isloading" class="loader"></div>

        <div v-else id="email__message">
          <div id="email__bodyelement__sender">
            <v-alert
              type="info"
              style="padding: 6px; font-size: 14px; margin-bottom: 0px"
            >
              Edited Version Copy of EFID:{{ lastupdatedefid
              }}<span v-if="lastupdatedefid == ''"> NA </span>
            </v-alert>

            <div
              id="email__bodyelement__sender--4"
              v-if="efid"
              style="font-weight: bold"
            >
              Edited Version EFID - <span>{{ efid }}</span>
            </div>
            <div
              v-html="not_valid_message"
              style="
                font-weight: bold;
                padding-top: 10px;
                padding-left: 10px;
                color: #ff6666;
              "
            ></div>

            <v-row id="email__bodyelement__sender--1">
              <div id="email__history__deletemsg">
                {{ forwardemail_delete_msg }}
              </div>

              <v-col cols="8" style="">
                <v-text-field
                  label="Forward To"
                  v-on:blur="validate"
                  v-model="forward_to"
                  ref="fontsize18"
                  outlined
                  dense
                />
                <input type="hidden" :muid="muid" v-model="ids" />
              </v-col>
            </v-row>
            <v-row id="email__bodyelement__sender--2">
              <v-col cols="8" style="">
                <v-checkbox v-model="checkbox" :label="`Cc`"></v-checkbox>
                <v-text-field
                  v-on:blur="validate"
                  label="Cc:"
                  v-model="cc"
                  ref="fontsize18"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <v-row id="email__bodyelement__sender--3">
              <v-col cols="8" style="">
                <v-text-field
                  v-on:blur="validate"
                  label="Subject"
                  v-model="forward_subject"
                  ref="fontsize18"
                  outlined
                  dense
                />
                <input type="hidden" :muid="muid" v-model="ids" />
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12" no-gutters style="padding: 20px">
                <!-- <ejs-richtexteditor ref="rteObj" v-model="editorData" :enableResize="true" :height="740" :toolbarSettings="toolbarSettings"
                  :insertImageSettings="insertImageSettings"
                  >
                </ejs-richtexteditor> -->
                <ejs-richtexteditor ref="rteObj" v-model="editorData" :enableResize="true" :height="740" 
                  :toolbarSettings="toolbarSettings"
                  :quickToolbarSettings="quickToolbarSettings"
                  :insertImageSettings="insertImageSettings"
                  :toolbarClick="toolbarClick"
                  >
                </ejs-richtexteditor>
                <ejs-dialog
                    ref="dialogObj"
                    :buttons="dlgButtons"
                    :beforeOpen="OnBeforeOpen"
                    :header="header"
                    :visible="visible"
                    :showCloseIcon="showCloseIcon"
                    width="800px"
                    height="800px"
                    :close="onClose"
                    :isModal="isModal"
                    >
                  <div>
                      <ejs-imageeditor                
                      ref="imageEditorObj"
                      id="image-editor"
                      height="335px"
                      ></ejs-imageeditor>
                  </div>
                </ejs-dialog> 
                 <!-- <editor
                  v-model="editorData"
                  api-key="og2kn37ji0eoavczsyr750unzxo5o447vj9e774i3apk9g5z"
                  :init="{
                    selector: 'textarea#full-featured-non-premium',
                    height: editorConfig['height'],
                    menubar: true,
                    toolbar_sticky: true,
                    toolbar_mode: 'wrap',
                    plugins: [
                      'print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons',
                    ],
                    toolbar:
                      'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl',
                  }"
                /> -->
              </v-col>
            </v-row>
            <div id="searchform__button--1">
              <v-btn
                color="primary"
                @click="removelinks"
                style="
                  margin: 0px 0px 10px 22px;
                  width: 100px;
                  height: 22px;
                  font-size: 10px;
                "
                >Remove Link</v-btn
              >
            </div>

            <v-row no-gutters>
              <v-col cols="1" style="margin-left: 20px; padding-left: 0px">
                Message:
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12" no-gutters style="padding: 20px">
                <ejs-richtexteditor ref="rteObj" :value="editormsgData" :toolbarSettings="toolbarSettings" :enableResize="true" >
                </ejs-richtexteditor>
                <!-- <wysiwyg v-model="editormsgData"></wysiwyg> -->
                <!-- <froala id="edit" :tag="'textarea'" v-model="editormsgData" /> -->
                <!-- <editor
                  v-model="editormsgData"
                  api-key:api_key
                  :init="{
                    height: editorConfig_msg['height'],
                    menubar: false,
                    plugins: [
                      'advlist autolink lists link image charmap print preview anchor',
                      'searchreplace visualblocks code fullscreen',
                      'insertdatetime media table paste code help wordcount',
                    ],
                    toolbar:
                      'formatselect | bold italic backcolor | \
                                alignleft aligncenter alignright alignjustify | \
                                bullist numlist outdent indent | removeformat',
                  }"
                /> -->
              </v-col>
            </v-row>
          </div>
          <div id="attachments">
            <div id="email__attachment" v-if="attachments != ''">
              <div id="email__attachment__mainheading">Attachments</div>
              <div
                id="email__attachment__success"
                v-if="fileuploadsuccesmsg != ''"
              >
                {{ fileuploadsuccesmsg }}
              </div>
              <div
                id="email__attachment__deleted"
                v-if="deleteattachmessage != ''"
              >
                {{ deleteattachmessage }}
              </div>
              <div id="email__attachment__heading">
                <div id="email__attachment__heading--1">S No.</div>
                <div id="email__attachment__heading--2">File Name</div>
                <div id="email__attachment__heading--3">Date</div>

                <div id="email__attachment__heading--4">Action</div>
              </div>
              <div
                v-for="(attachment, i) in attachments"
                v-bind:key="i"
                :class="emailClass(i)"
                id="email__header3"
              >
                <div id="email__attachment__header--1">
                  <!--
                              <input v-model="attachment_checkbox" type="checkbox" :value="attachment.ceafpath"
                            v-on:click="checkboxattfile($event,attachment.ceafid)" >
                            -->
                  {{ i + 1 }}
                </div>
                <div id="email__attachment__header--2">
                  {{ attachment.filename }}
                </div>
                <div id="email__attachment__header--3">
                  {{ attachment.ceafdate }}
                </div>

                <div id="email__attachment__header--4">
                  <v-icon
                    id="icon_style"
                    v-on:click="downloadattachment(attachment.ceafid, $event)"
                    data-inline="true"
                    title="Download"
                    >mdi-download</v-icon
                  >
                  <v-icon
                    v-on:click="opendeleteattachconfirmbox(attachment.ceafid)"
                    id="icon_style"
                    title="Delete"
                    >mdi-delete</v-icon
                  >
                </div>
              </div>
            </div>
          </div>

          <div style="text-align: center">
            <input type="hidden" :muid="muid" v-model="muid" />
            <div id="searchform__button--1">
              <div v-if="fileuploadermsg != ''" style="color: red">
                {{ fileuploadermsg }}
              </div>
              <v-btn color="primary" @click="opensaveemail" style="margin: 20px"
                >Save Product Info</v-btn
              >
              <v-btn color="primary" @click="opensendemail" style="margin: 20px"
                >Save & Send</v-btn
              >
              <v-btn
                color="primary"
                @click.stop="dialog = true"
                style="margin: 20px"
                >Cancel</v-btn
              >
            </div>
          </div>
        </div>
      </div>

      <div id="Forwarded">
        <div id="email__history">
          <div id="email__history__mainheading">
            <v-row>
              <v-col cols="11" no-gutters style="padding: 20px">
                <v-progress-linear
                  v-if="showattachmentprogress == true"
                  indeterminate
                  color="green"
                ></v-progress-linear>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="11" no-gutters style="padding: 0px">
                <div
                  style="
                    font-size: 12px;
                    margin: 5xp;
                    padding: 10px;
                    font-weight: normal;
                    color: green;
                  "
                >
                  *Allowed File types are :
                  html,jpeg,png,gif,pdf,doc,docx,xls,xlsx,ppt,pptx and txt
                </div>

                <v-file-input
                  multiple
                  v-model="file"
                  label="Attachment"
                  placeholder="Select your files"
                  outlined
                  dense
                  chips
                  @change="onAddFiles"
                />
              </v-col> </v-row
            ><span v-if="forwardeddata != ''"> History</span>
          </div>

          <div id="email__history__heading" v-if="forwardeddata != ''">
            <div id="email__history__heading--1">EFID</div>
            <div id="email__history__heading--2">Date</div>
            <div id="email__history__heading--3">Subject</div>
            <div id="email__history__heading--4">Sender/Creator</div>
            <div id="email__history__heading--5">Receipient</div>
            <div id="email__history__heading--6">Action</div>
          </div>
          <div
            v-for="(forwardData, i) in forwardeddata"
            v-bind:key="i"
            :class="emailClass(i)"
            id="email__header3"
          >
            <div id="email__header3--1">
              {{ forwardData.efid }}
              <span v-if="forwardData.forward_to == ''" style="color: green"
                >Drafted</span
              >
            </div>
            <div id="email__header3--2">{{ forwardData.efdate }}</div>
            <div id="email__header3--3">{{ forwardData.forward_subject }}</div>
            <div id="email__header3--4">
              <span>{{ forwardData.forward_from }} </span>
            </div>
            <div id="email__header3--5">
              {{ forwardData.forward_to }}
              <span v-if="forwardData.cc != ''">,{{ forwardData.cc }}</span>
            </div>

            <div id="email__header3--6">
              <v-icon
                id="icon_style"
                @click="openPopUp(forwardData.efid)"
                data-inline="true"
                title="View Html"
                >mdi-eye</v-icon
              >
              <v-icon
                id="icon_style"
                @click="openprocesshtmlPopUp(forwardData.efid)"
                data-inline="true"
                title="View Processed Html"
                >mdi-file-code</v-icon
              >
              <v-icon
                @click="openpdfPopUp(forwardData.efid)"
                id="icon_style"
                title="View Processed PDF"
                >mdi-file-pdf-box</v-icon
              >
              <v-icon
                v-on:click="getHtmlDataEdit(forwardData.id)"
                id="icon_style"
                data-inline="true"
                title="Edit"
                >mdi-book-edit</v-icon
              >
              <v-icon
                v-on:click="opendeleteConfirmBox(forwardData.id)"
                id="icon_style"
                title="Delete"
                >mdi-delete</v-icon
              >
            </div>
          </div>
        </div>
      </div>
    </form>
    <template>
      <v-row>
        <v-dialog v-model="dialog" max-width="290">
          <v-card>
            <v-card-title class="headline"> </v-card-title>

            <v-card-text> Are you sure you want to Cancel </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="green darken-1" text @click="cancel"> Yes </v-btn>

              <v-btn color="green darken-1" text @click="dialog = false">
                No
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
  <v-row>
    <v-dialog v-model="savedialog" max-width="290">
      <v-card>
        <v-card-title class="headline"> </v-card-title>

        <v-card-text>
          <div
            v-show="successMessage"
            id="success"
            :style="{
              backgroundColor: messagecolor,
              color: color,
              textAlign: align,
              margin: margin,
            }"
          >
            {{ messages }}
          </div>

          <span
            v-if="
              messages == '' && saveonly == false && sendinprogress == false
            "
          >
            Are you sure you want to Send Email
          </span>
          <span
            v-if="messages == '' && saveonly == true && sendinprogress == false"
          >
            Are you sure you want to Save Email
          </span>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <div
            v-if="sendinprogress == true"
            style="position: absolute; top: 20px; left: 50px"
          >
            Processing..
          </div>

          <v-btn
            color="green darken-1"
            text
            @click="saveandSend"
            v-if="messages == '' && sendinprogress == false"
          >
            Yes
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="savedialog = false"
            v-if="messages == '' && sendinprogress == false"
          >
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<template>
  <v-row>
    <v-dialog v-model="deletedialog" max-width="290">
      <v-card>
        <v-card-title class="headline"> </v-card-title>

        <v-card-text>
          <div
            v-show="successMessage"
            id="success"
            :style="{
              backgroundColor: messagecolor,
              color: color,
              textAlign: align,
              margin: margin,
            }"
          >
            {{ deletedmailmessage }}
          </div>
          <div v-if="is_delete_email_button_disable == false">
            Are you sure you want to Delete this Email?
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <div
            v-if="is_delete_email_button_disable == true"
            style="position: absolute; top: 29px; left: 105px"
          >
            Deleting..
          </div>

          <v-btn
            v-if="is_delete_email_button_disable == false"
            color="green darken-1"
            text
            v-on:click="deleteForwardedEmail()"
          >
            Yes
          </v-btn>

          <v-btn
            v-if="is_delete_email_button_disable == false"
            color="green darken-1"
            text
            @click="deletedialog = false"
          >
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>



<template>
  <v-row>
    <v-dialog v-model="deleteattachdialog" max-width="290">
      <v-card>
        <v-card-title class="headline"> </v-card-title>

        <v-card-text>
          <div
            v-show="successMessage"
            id="success"
            :style="{
              backgroundColor: messagecolor,
              color: color,
              textAlign: align,
              margin: margin,
            }"
          >
            {{ deleteattachmessage }}
          </div>
          <div v-if="is_disable_attachment_button == false">
            Are you sure you want to Delete the File Attachment?
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <div
            v-if="is_disable_attachment_button == true"
            style="position: absolute; top: 20px; left: 105px"
          >
            Deleting..
          </div>

          <v-btn
            v-if="is_disable_attachment_button == false"
            color="green darken-1"
            text
            @click="deleteattachment"
          >
            Yes
          </v-btn>

          <v-btn
            v-if="is_disable_attachment_button == false"
            color="green darken-1"
            text
            @click="deleteattachdialog = false"
          >
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>



<!-- Show html pop up -->
<template>
  <v-row>
    <v-dialog width="1080" height="1000" v-model="forwared_dialog">
      <v-card>
        <v-card-text v-html="viewforwardhtml"> </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
  </div>
  
</template>

 


  


<script>
/* eslint-disable no-unused-vars */
/* eslint-disable vue/no-unused-components */

import axios from "axios";
// import Editor from "@tinymce/tinymce-vue";
import { mapGetters } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { RichTextEditorComponent, Toolbar, PasteCleanup, Resize, FormatPainter, HtmlEditor, Link, Count,Image, QuickToolbar, Table, NodeSelection } from "@syncfusion/ej2-vue-richtexteditor";
import { DialogComponent } from "@syncfusion/ej2-vue-popups";
import { ImageEditorComponent } from "@syncfusion/ej2-vue-image-editor";
import{ getComponent }from'@syncfusion/ej2-base';
import { ImageEditor } from '@syncfusion/ej2-image-editor';

export default {
  name: "Editor",
  components: {
    // editor: Editor,
    Loading,
    "ejs-richtexteditor": RichTextEditorComponent,
    'ejs-dialog': DialogComponent,
    'ejs-imageeditor': ImageEditorComponent
  },
  data(){
    return {
      apc_process_msg: false,
      fullPage: true,
      apc_process_status: "",
      working: false,
      editor: "",
      message_editor: "",
      muid: "",
      messages: "",
      messagecolor: "",
      color: "",
      align: "",
      margin: "",
      successMessage: true,
      forwardedmsg: [],
      forward_subject: "",
      forward_to: "electronicteam@suntecindia.com",
      checkbox: true,
      checkedthis: false,
      emaildetail: "",
      editorData: "",
      editormsgData: "",
      ids: "",
      // panelistid:null,
      editorConfig: {
        // The configuration of the editor.
        height: 1000,
      },
      editorConfig_msg: {
        // The configuration of the editor.
        height: 300,
      },
      username: "",
      cc: "",
      lastforwardid: "",
      render_url: "",
      dialog: false,
      savedialog: false,
      sendflag: false,
      sendinprogress: false,
      attachments: "",
      viewforwardhtml: "",
      forwared_dialog: false,
      deletedialog: false,
      deletedmailid: "",
      deletedattachmentid: "",
      deletedmailmessage: "",
      deleteattachmessage: "",
      download_attachment_url: "",
      deleteattachdialog: false,
      fileuploadermsg: "",
      showattachmentprogress: false,
      checked_attachmentid: [],
      fileuploadsuccesmsg: "",
      fileattflag: false,
      attachement_delete_msg: "",
      forwardemail_delete_msg: "",
      focus: false,
      attachment_checkbox: [],
      api_key: "",
      saveonly: false,
      chekcedstr: "",
      efid: "",
      file: null,
      process_html_url: "",
      process_pdf_url: "",
      lastupdatedefid: "",
      file_atach_ids: [],
      file_attach_str: "",
      is_disable_attachment_button: false,
      is_valid_email: "",
      is_valid_cc: "",
      not_valid_message: "",
      is_delete_email_button_disable: false,
      scores: [],
      update_working: false,
      update_done: false,

      toolbarSettings: {
          type: 'MultiRow',
          items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
          'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
          'LowerCase', 'UpperCase', '|',
          'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
          'Outdent', 'Indent', '|',
          'CreateLink', 'Image', '|', 'ClearFormat', 'Print',
          'SourceCode', 'FullScreen', '|', 'Undo', 'Redo'
        ]
      },
      insertImageSettings: {
        saveUrl: 'https://services.syncfusion.com/vue/production/api/RichTextEditor/SaveFile',
        removeUrl: 'https://services.syncfusion.com/vue/production/api/RichTextEditor/DeleteFile',
        path: 'https://services.syncfusion.com/vue/production/RichTextEditor/',
        // saveFormat: 'Base64'
      },
      visible: false,
      showCloseIcon: false,
      isModal: false,
      selection: new NodeSelection(),
      ranges: null,
      saveSelection: null,
      dataURL: null,
      isLoaded: false,
      imageELement: null,
      imageEditorObj: null,
      dlgButtons: [
        {
          buttonModel: { content: 'Insert', isPrimary: true },
          click: this.onInsert.bind(this),
        },
        { buttonModel: { content: 'Cancel' }, click: this.onCancel },
      ],
      header: 'Image Editor',
      quickToolbarSettings: {
        image: [
          'Replace',
          'Align',
          'Caption',
          'Remove',
          '-',
          'InsertLink',
          'OpenImageLink',
          'EditImageLink',
          'RemoveImageLink',
          'Display',
          'AltText',
          {
            tooltipText: 'Image Editor',
            template:
              '<button class="e-tbar-btn e-btn" id="imageEditor"><span class="e-btn-icon e-icons e-rte-image-editor"></span></button>',
          },
        ],
      },
    }
  },

  mounted() {
    this.$store.dispatch("RawData/setBigLoading", true);
    let sidebar = this.$store.getters["RawData/getSidebar"];
    console.log(this.$store.state.RawData.current_active_module, "sto")
    let check =  this
    let current_active_mod = null
    sidebar.forEach((module)=>{
      if(check.$route.path.toLowerCase() === '/' && check.$route.path.toLowerCase() === module.to.toLowerCase()  && current_active_mod === null){
          current_active_mod = module 
      }else if(check.$route.path.toLowerCase() !== '/' && module.to.toLowerCase() !== '/' && check.$route.path.toLowerCase().includes(module.to.toLowerCase())  && current_active_mod === null){
      current_active_mod = module
      }
    })
    check.$store.dispatch("RawData/setCurrentActiveModule", current_active_mod)
    console.log(current_active_mod, 999)
  },
  computed: {
    ...mapGetters({
      muids: "Email/getMuid",
      status: "Email/getStatus",
      subject: "Email/getSubject",
      points: "Email/getPoints",
      date: "Email/getDate",
      forwardto: "Email/getForwardTo",
      message: "Email/getEmailBody",
      isloading: "Email/getIsLoading",
      firstname: "Email/getFirstname",
      lastname: "Email/getLastname",
      state: "Email/getState",
      age: "Email/getAge",
      panelistemail: "Email/getPanelistemail",
      panelistid: "Email/getPanelist",
      forwardeddata: "Email/getForwardeddata",
      bigLoading: "RawData/getBigLoading",
      allstatus: "RawData/getAllStatus",
      deleted: "Email/getDeleted",
    }),
    emailPoints: {
      get: function () {
        let newpoints = "";
        let points = this.$store.getters["Email/getPoints"];
        if (typeof points != "string") {
          newpoints = points.toString();
        }
        return newpoints;
      },
      set: function (o) {
        let view = this;
        let panelistScore = parseInt(o);
        let muid = this.$store.getters["Email/getMuid"];
        let indexName = this.$store.getters["Email/getIndexName"];
        view
          .$fetch(
            {
              url: view.$url("UPDATE_SCORE"),
              type: "POST",
              data: JSON.stringify({
                muid: muid,
                panelist_score: panelistScore,
                index_name: indexName,
              }),
              contentType: "application/json",
            },
            {
              operation: "add",
              vueScope: view,
            }
          )
          .then(function (response) {
            if (
              typeof response.status !== "undefined" &&
              response.status === "ok"
            ) {
              view.$store.dispatch("Email/setPanelistScore", parseInt(o));
              view.$store.dispatch("Email/setPoints", parseInt(o));
              view.$swal.fire({
                position: "bottom-end",
                icon: "success",
                title: "Points Updated Successfully!",
              });
            }
          })
          .catch(function (err) {
            console.log(err);
            view.$swal.fire({
              position: "bottom-end",
              icon: "error",
              title: err.responseJSON.payload.msg,
            });
          });
      },
    },
    productLink: function () {
      return "/product/" + this.muid;
    },
    allstatus: function () {
      let statuses = this.$store.getters["RawData/getAllStatus"];
      return statuses;
    },

    status_without_junk: function () {
      let statuses = this.$store.getters["RawData/getAllStatus"];
      console.log("status---" + statuses);
      if (statuses != undefined) {
        return statuses.filter((s) => s.value != 3 && s.value != 2);
      } else {
        return statuses;
      }
    },
    updateStatus: {
      get: function () {
        return this.$store.getters["Email/getDeleted"];
      },
      set: function (o) {
        var view = this;
        view.$store
          .dispatch("Email/setDeleted", o)
          .then(function () {
            view.update_working = true;
            return view.updateEmailRead();
          })
          .then(function () {
            view.update_working = false;
            view.update_done = true;
            setTimeout(function () {
              view.update_done = false;
            }, 5000);
          });
      },
    },
    current_status: function () {
      var view = this,
        deleted = view.$store.getters["Email/getDeleted"],
        status = view.allstatus.filter((o) => o.value === deleted);
      if (Array.isArray(status) && status.length > 0) {
        return status[0].text;
      }
      return "";
    },
  },
  watch: {
    "$store.state.RawData.current_active_module": function (o) {
      console.log(o, "ooooo")
      if (o) {
        let view = this;
        console.log('calling');
        if (!view.$store.getters["RawData/getDone"]) {
          console.log(view, "view");
          view
            .$fetch(
              {
                url: view.$url("RAW_DATA"),
                type: "GET",
              },
              {
                operation: "view",
                vueScope: view,
              }
            )
            .then(function (response) {
              view.$store.dispatch("RawData/setBigLoading", false);
              typeof response.totSpacey2019Emails === "undefined"
                ? ""
                : localStorage.setItem(
                    "totSpacey2019Emails",
                    response.totSpacey2019Emails
                  );
              typeof response.totSpacey2019Emails === "undefined"
                ? ""
                : localStorage.setItem(
                    "totSpaceyEmails",
                    response.totSpaceyEmails
                  );
              typeof response.totEmails === "undefined"
                ? ""
                : view.$store
                    .dispatch("Emails/setTotalEmails", response.totEmails)
                    .then(() => {
                      typeof response.totSpaceyEmails === "undefined"
                        ? ""
                        : view.$store
                            .dispatch(
                              "Emails/setTotalSpaceyEmails",
                              response.totSpaceyEmails
                            )
                            .then(() => {
                              view.$store
                                .dispatch("RawData/setRawData", response)
                                .then(() => {
                                  view.$store.dispatch("RawData/setDone", true);
                                  var arr = new Array(),
                                    score =
                                      view.$store.getters[
                                        "RawData/getAllScores"
                                      ];
                                  if (
                                    view.$store.getters[
                                      "Emails/getRequestPayload"
                                    ].panelist === "producer"
                                  ) {
                                    score.prod_score.forEach(function (o) {
                                      arr.push({ text: o, value: o });
                                    });
                                    view.scores = arr;
                                  } else {
                                    score.score.forEach(function (o) {
                                      arr.push({ text: o, value: o });
                                    });
                                    view.scores = arr;
                                  }
                                });
                            });
                    });
              typeof response.states === "undefined"
                ? ""
                : view.$store.dispatch("RawData/setStates", response.states);
            })
            .catch(function (e) {
              console.log(e);
              view.$store.dispatch("RawData/setBigLoading", false);
            });
        } else {
          var arr = new Array(),
            score = view.$store.getters["RawData/getAllScores"];
          if (
            view.$store.getters["Emails/getRequestPayload"].panelist ===
            "producer"
          ) {
            score.prod_score.forEach(function (o) {
              arr.push({ text: o, value: o });
            });
            view.scores = arr;
          } else {
            score.score.forEach(function (o) {
              arr.push({ text: o, value: o });
            });
            view.scores = arr;
          }
        }
        this.username = this.$utils.getCookies("email");
        this.cc = this.username.replace('"', "").replace('"', "");
        this.getMuid();
        this.render_url = this.$url("RENDER_HTML") + this.muid;
        this.download_attachment_url =
          this.$url("DOWNLOAD_ATTACHMENTS") + "/" + this.muids;
        this.$store.dispatch("RawData/setBigLoading", true);
        this.$utils.getForwardedEmail(this);
        this.$utils.getEmailDetails(this);
        //this.getHtmlData()
        this.getLastForwardedid();
        this.getAttachments();
        this.api_key = this.$url("TINY_MCE_API");
        window.onbeforeunload = null;
      }
    },
    "$store.state.Email.subject": function (o) {
      if (o!='') {
        if(this.$store.getters["Email/getEmailRead"] == 0){
          this.updateEmailRead();
        }
      }
      }
    //   emailPoints:function(o){
    //       console.log(o);
    //     this.$store.dispatch('Email/setPanelistScore', o)
    //   }
  },
  methods: {
    toolbarClick: function (args) {
      if (args.item.tooltipText === 'Image Editor') {
        this.range = this.selection.getRange(document);
        this.saveSelection = this.selection.save(this.range, document);
        this.$refs.dialogObj.show();
        this.$refs.rteObj.ej2Instances.quickToolbarModule.imageQTBar.hidePopup();
      }
    },
    onInsert: function () {
      if (
        this.$refs.rteObj.ej2Instances.formatter.getUndoRedoStack()
          .length === 0
      ) {
        this.$refs.rteObj.ej2Instances.formatter.saveData();
      }
      this.saveSelection.restore();
      var canvas = document.createElement('CANVAS');
      var ctx = canvas.getContext('2d');
      const imgData = this.imageEditorObj.getImageData();
      canvas.height = imgData.height;
      canvas.width = imgData.width;
      ctx.putImageData(imgData, 0, 0);
      this.isLoaded = true;
      this.$refs.rteObj.executeCommand('editImage', {
        url: canvas.toDataURL(),
        width: { width: canvas.width },
        height: { height: canvas.height },
        selection: this.saveSelection,
        cssClass: this.imageELement
          .getAttribute('class')
          .replace('e-rte-image', ''),
      });
      this.$refs.rteObj.ej2Instances.formatter.saveData();
      this.dispose();
      this.$refs.dialogObj.hide();
      this.imageELement.crossOrigin = null;
    },
    onCancel: function () {
      this.dispose();
      this.$refs.dialogObj.hide();
      this.isLoaded = true;
      this.imageELement.crossOrigin = null;
    },
    onClose: function () {
      this.dispose();
      this.$refs.dialogObj.hide();
      this.isLoaded = true;
      this.imageELement.crossOrigin = null;
    },
    dispose: function () {
      var imageEditorInstance = getComponent(
        document.getElementById('image-editor'),
        'image-editor'
      );
      if (imageEditorInstance !== null && imageEditorInstance !== undefined) {
        imageEditorInstance.destroy();
      }
    },
    OnBeforeOpen: function () {
      this.dispose();
      this.isLoaded = false;
      var selectNodes =
        this.$refs.rteObj.ej2Instances.formatter.editorManager.nodeSelection.getNodeCollection(
          this.range
        );
      if (selectNodes.length == 1 && selectNodes[0].tagName == 'IMG') {
        this.imageELement = selectNodes[0];
        this.imageELement.crossOrigin = 'anonymous';
        var canvas = document.createElement('CANVAS');
        var ctx = canvas.getContext('2d');
        canvas.height = this.imageELement.offsetHeight;
        canvas.width = this.imageELement.offsetWidth;
        var imageELe = this.imageELement;
        var isLoded = this.isLoaded;
        const onImageLoadEvent = () => {
          ctx.drawImage(imageELe, 0, 0, canvas.width, canvas.height);
          this.dataURL = canvas.toDataURL();
          if (!isLoded) {
            this.imageEditorObj = new ImageEditor({
              height: '450px',
              created: () => {
                this.imageEditorObj.open(this.dataURL);
              },
            });
            this.imageEditorObj.appendTo('#image-editor');
            isLoded = true;
          }
          this.imageELement.removeEventListener('load', onImageLoadEvent);
        };
        this.imageELement.addEventListener('load', onImageLoadEvent);
      }
    },

    updateEmailRead: function () {
      var view = this;
      console.log({
        type: "update",
        payload: [
          {
            muid: view.$store.getters["Email/getMuid"],
            deleted: view.$store.getters["Email/getDeleted"],
            panelist_core: view.$store.getters["Email/getPanelistCore"],
            panelist_score: view.$store.getters["Email/getPanelistScore"],
            email_read: 1,
            index_name: view.$store.getters["Email/getIndexName"],
          },
        ],
      });
      console.log(
        JSON.stringify({
          type: "update",
          payload: [
            {
              muid: view.$store.getters["Email/getMuid"],
              deleted: view.$store.getters["Email/getDeleted"],
              panelist_core: view.$store.getters["Email/getPanelistCore"],
              panelist_score: view.$store.getters["Email/getPanelistScore"],
              email_read: 1,
              index_name: view.$store.getters["Email/getIndexName"],
            },
          ],
        })
      );
      return view.$fetch({
        url: view.$url("EMAILS"),
        type: "POST",
        data: JSON.stringify({
          type: "update",
          payload: [
            {
              muid: view.$store.getters["Email/getMuid"],
              deleted: view.$store.getters["Email/getDeleted"],
              panelist_core: view.$store.getters["Email/getPanelistCore"],
              panelist_score: view.$store.getters["Email/getPanelistScore"],
              email_read: 1,
              index_name: view.$store.getters["Email/getIndexName"],
            },
          ],
        },{
                operation: 'add',
                vueScope: view
            }),
        contentType: "application/json",
      });
    },
    manageProduct: function () {
      var view = this;
      window.open(
        "/product/v2/" + view.muid,
        "emailbodypopup",
        "width=900,height=700"
      );
      window.focus();
    },
    manageProductV2: function () {
      var view = this;
      window.open(
        view.$url("PRODUCT_V2_URL") + "product-entry/temp/" + view.muid,
        "_blank"
      );
      window.focus();
    },
    
     onAddFiles(files) {
            let accestoken = this.$utils.getAccessToken()
            let user_id = this.$utils.getCookies("user_id");
            let file = ''
            var view = this
            if(files.length == 0){
                view.showattachmentprogress = false
                 return;
            }
            let index= 0
            let total_size = 0
            for (index in files){
                total_size = total_size + files[index].size
            }
            total_size = (total_size / (1024*1024)).toFixed(2)
            if (total_size > 100){
                view.fileuploadermsg = 'Please upload max file size up to 100MB'
                view.showattachmentprogress = false
                setTimeout(() => view.fileuploadermsg = '', 5000)
                return;
            }
            view.fileuploadermsg = ''
            view.showattachmentprogress = true
            var route = view.$route
            var id = route.params.muid
            var endPoint = view.$url('UPLOAD_ATTACHMENTS')
             for (index in files){
                 let formData = new FormData();
                 file =files[index]
                 formData.append('email_attachment', file);
                axios.post(endPoint+'/'+id,
                    formData, {
                        headers: {
                        'Authorization': accestoken,
                          'userid':user_id,
                        'Content-Type': 'multipart/form-data'
                        }
                    }
                    ).then(function (response) {
                    console.log(response)
                    index = index +1
                    view.showattachmentprogress = false
                    view.fileattflag=true
                        view.getAttachments()
                        view.fileuploadsuccesmsg='File uploaded successfully'
                        view.fileuploadermsg = ''
                        view.file=''
                        //view.file =null
                        var attachment = document.getElementById("attachments");
                        attachment.scrollIntoView();
                        setTimeout(() => view.fileuploadsuccesmsg = '', 10000)
                    }).catch(function (response) {
                        view.showattachmentprogress = false
                        view.fileuploadsuccesmsg=''
                         if(response.message=='Network Error'){
                            view.fileuploadermsg = 'something went wrong'
                        }else{
                            if (response.response.status == 500){
                             view.fileuploadermsg = 'File type not supported.'
                            }else{
                                view.fileuploadermsg = 'something went wrong please refresh and try to upload again'
                            }
                        }
                        view.file=''
                        setTimeout(() => view.fileuploadermsg = '', 10000)
                    });
             }
        },
    goBack: function () {
      //this.$router.go(-1)
      this.$router.push({ path: "/" });
    },

    emailClass: function (i) {
      return parseInt(i) % 2 === parseInt(0)
        ? "grey lighten-2"
        : "grey lighten-5";
    },
    formatString: (str) => {
      str = str.replace(/[\\_]/g, "");
      str = str.replace(/[//_]/g, "");
      return str;
    },
    removelinks: function () {
      if (confirm("Are you sure to remove all links?")) {
        try{
          const parser = new DOMParser();
          const doc = parser.parseFromString(this.editorData, 'text/html');

          doc.querySelectorAll('a').forEach(anchor => {
            anchor.href = "javascript:;"
            anchor.style.pointerEvents = 'none'; 
            anchor.style.cursor = 'default';
          });

          const cleanedHtml = doc.documentElement.outerHTML;
          
          this.editorData = cleanedHtml?.replace(/&quot;/g, "'")          
        }catch(e){
          console.error(e);
        }
      }
    },
    getHtmlData: function (ids = "") {
      var view = this;
      view.showattachmentprogress = false;
      var idsstr = "";
      if (ids != "") {
        idsstr = "/" + ids;
      }
      var route = view.$route;
      var endPoint = view.$url("HTMLBODY");
      var id = route.params.muid;
      view
        .$fetch(
          {
            url: endPoint + "/" + id + idsstr,
            type: "GET",
            crossDomain: true,
          },
          {
            operation: "view",
            vueScope: view,
          }
        )
        .then(function (response) {
          view.$store.dispatch("RawData/setBigLoading", false);
          if (typeof response.muid !== "undefined") {
            view.editorData = response.body;
            view.editormsgData = response.message;
            view.forward_subject = response.subject;
            view.lastupdatedefid = response.ids;

            var element = document.getElementById("email__bodyelement");
            element.scrollIntoView();
          }
        })
        .catch(function (e) {
          console.log(e);
        });
    },

    getHtmlDataEdit: function (ids = "") {
      var view = this;
      view.showattachmentprogress = false;
      var idsstr = "";
      if (ids != "") {
        idsstr = "/" + ids;
      }

      view.efid = ids;
      var route = view.$route;
      var endPoint = view.$url("HTMLBODY");
      var id = route.params.muid;
      view
        .$fetch(
          {
            url: endPoint + "/" + id + idsstr,
            type: "GET",
            crossDomain: true,
          },
          {
            operation: "view",
            vueScope: view,
          }
        )
        .then(function (response) {
          view.$store.dispatch("RawData/setBigLoading", false);
          if (typeof response.muid !== "undefined") {
            view.editorData = response.body;
            view.forward_subject = response.subject;
            view.editormsgData = response.message;
            view.ids = response.ids;
            var element = document.getElementById("email__bodyelement");
            element.scrollIntoView();
          }
        })
        .catch(function (e) {
          console.log(e);
        });
    },

    saveEmail(payload) {
      var view = this;

      view
        .$fetch(
          {
            url: view.$url("HTMLBODY"),
            type: "POST",
            data: JSON.stringify(payload),
            crossDomain: true,

            contentType: "application/json",
          },
          {
            operation: "add",
            vueScope: view,
          }
        )
        .then(function (response) {
          console.log("successfully saved");

          view.$utils.getForwardedEmail(view);
          view.$utils.getEmailDetails(view);
          view.lastforwardid = response.result.ids;
          view.lastupdatedefid = response.result.ids;

          if (view.saveonly == false) {
            view.sendEmail(response.result.ids);
          } else {
            view.messages = "Email saved Successfully!";
            view.fileuploadsuccesmsg = "";
            view.sendinprogress = false;
            //view.editormsgData=''
            view.fileuploadermsg = "";
            view.messagecolor = "#ccc";
            view.color = "#000";
            view.align = "center";
            view.margin = "0px 13px 0px 13px";
            view.attachment_checkbox = [];
            setTimeout(() => (view.savedialog = false), 5000);
          }

          //view.editormsgData=''

          view.showattachmentprogress = false;
          view.fileuploadsuccesmsg = "";
          //view.ids=''
          var element = document.getElementById("email__bodyelement");
          element.scrollIntoView();
        })
        .catch(function (e) {
          console.log(e);
        });
    },
    sendEmail(ids) {
      //this.saveEmail(payloadnew)
      const payloadnew = {
        body: this.editormsgData,
        muid: this.muids,
        subject: this.forward_subject,
        forward_to: this.forward_to,
        cc: this.checkbox == true ? this.cc : "",
        ids: ids,
        attachids: this.attachment_checkbox.length == 0 ? "" : this.chekcedstr,
        attach_path:
          this.attachment_checkbox.length == 0 ? "" : this.file_attach_str,
        forward_from: this.username.replace('"', ""),
      };

      console.log("clicked on send email");
      console.log("payload------>" + JSON.stringify(payloadnew));

      var view = this;
      view
        .$fetch(
          {
            url: view.$url("SENDMAIL"),
            type: "POST",
            data: JSON.stringify(payloadnew),
            contentType: "application/json",
            crossDomain: true,
          },
          {
            operation: "add",
            vueScope: view,
          }
        )
        .then(function () {
          view.sendflag = true;
          view.sendinprogress = false;
          view.messages = "Email send Successfully!";
          view.fileuploadsuccesmsg = "";
          //view.editormsgData=''
          view.fileuploadermsg = "";
          view.messagecolor = "#ccc";
          view.color = "#000";
          view.align = "center";
          view.margin = "0px 13px 0px 13px";
          view.attachment_checkbox = [];
          //view.ids=''

          setTimeout(() => (view.savedialog = false), 5000);
        })
        .catch(function (e) {
          view.sendinprogress = false;
          view.messages = "Something went wrong!";

          setTimeout(() => {
            view.savedialog = false;
            view.messages = "";
          }, 5000);

          console.log(e);
        });
    },
    getForwardToEmail: function () {
      var view = this;
      var endPoint = view.$url("GETFORWARD_EMAIL");
      view
        .$fetch(
          {
            url: endPoint,
            type: "GET",
            crossDomain: true,
          },
          {
            operation: "view",
            vueScope: view,
          }
        )
        .then(function (response) {
          view.$store.dispatch("RawData/setBigLoading", false);

          if (typeof response.forwardto !== "undefined") {
            view.forward_to = response.forwardto;
          }
        })
        .catch(function (e) {
          console.log(e);
        });
    },
    onSubmit(e) {
      e.preventDefault();
      const payload = {
        body: this.editorData,
        muid: this.muids,
        forward_subject: this.forward_subject,
        argtype: "forward",
        ids: this.ids,
      };
      // console.log('payload------>'+JSON.stringify(payload))

      if (
        confirm(
          "Are you sure you want to save                                                                                                                                                                                                                                                                                                                                                                                                                                                       ?"
        )
      ) {
        this.sendEmail(payload);
      }
    },
    saveandSend() {
      console.log("save and send");
      const payload = {
        body: this.editorData,
        muid: this.muids,
        forward_subject: this.forward_subject,
        argtype: "forward",
        ids: this.ids,
        forward_to: this.saveonly == true ? "" : this.forward_to,
        cc: this.saveonly == true ? "" : this.checkbox == true ? this.cc : "",
        forward_from: this.username.replace('"', "").replace('"', ""),
        foward_message: this.editormsgData,
      };
      this.messages = "";
      this.sendinprogress = true;
      this.messages = "";
      this.fileuploadsuccesmsg = "";
      console.log(payload);
      this.validate();

      if (
        this.is_valid_email == true &&
        this.is_valid_email_cc == true &&
        this.forward_subject !== ""
      ) {
        this.saveEmail(payload);
      } else {
        this.savedialog = false;
        this.sendinprogress = false;
        var element = document.getElementById("email__bodyelement");
        //this.getHtmlData()
        //this.efid = ''
        element.scrollIntoView();
      }
    },

    getLastForwardedid: function () {
      var view = this;
      var route = view.$route;

      var id = route.params.muid;
      var endPoint = view.$url("FORWARDEDEMAIL");
      view
        .$fetch(
          {
            url: endPoint + "/" + id,
            type: "GET",
            crossDomain: true,
          },
          {
            operation: "view",
            vueScope: view,
          }
        )
        .then(function (response) {
          view.$store.dispatch("RawData/setBigLoading", false);

          if (typeof response !== "undefined") {
            // console.log(response.forwardjson[0].id )

            if (response.forwardjson != "") {
              view.getHtmlData(response.forwardjson[0].id);
            } else {
              view.getHtmlData();
            }
          }
        })
        .catch(function (e) {
          console.log(e);
        });
    },
    cancel: function () {
      this.$router.go(this.$router.currentRoute);
    },
    editOriginal: function () {
      var element = document.getElementById("email__bodyelement");
      this.getHtmlData();
      this.efid = "";
      element.scrollIntoView();
    },
    getAttachments: function () {
      var view = this;
      view.efid = "";
      var route = view.$route;
      var id = route.params.muid;
      var endPoint = view.$url("GET_ATTACHMENTS");
      view
        .$fetch(
          {
            url: endPoint + "/" + id,
            type: "GET",
            crossDomain: true,
          },
          {
            operation: "view",
            vueScope: view,
          }
        )
        .then(function (response) {
          console.log(response);
          view.attachments = response;
        })
        .catch(function (e) {
          console.log(e);
        });
    },
    getMuid: function () {
      var view = this;
      var route = view.$route;
      view.muid = route.params.muid;
    },
    viewForwardedEmail: function (ids) {
      var view = this;
      view.efid = "";
      var idsstr = "";
      if (ids != "") {
        idsstr = "/" + ids;
      }

      view.viewforwardhtml = "";

      var route = view.$route;
      var endPoint = view.$url("HTMLBODY");
      var id = route.params.muid;
      view
        .$fetch(
          {
            url: endPoint + "/" + id + idsstr,
            type: "GET",
            crossDomain: true,
          },
          {
            operation: "view",
            vueScope: view,
          }
        )
        .then(function (response) {
          view.$store.dispatch("RawData/setBigLoading", false);
          if (typeof response.muid !== "undefined") {
            view.viewforwardhtml = response.body;
            view.forwared_dialog = true;
          }
        })
        .catch(function (e) {
          console.log(e);
        });
    },
    opendeleteConfirmBox: function (id) {
      this.deletedialog = true;
      this.deleteattachmessage = "";
      this.deletedmailmessage = "";
      this.deletedmailid = id;
      this.fileuploadsuccesmsg = "";
      if (this.efid !== null) this.efid = "";
    },
    deleteForwardedEmail: function () {
      var view = this;
      view.efid = "";
      view.is_delete_email_button_disable = true;

      var endPoint = view.$url("DELETE_FWD_EMAILS");
      var muid = view.muid;

      var id = view.deletedmailid;
      view
        .$fetch(
          {
            url: endPoint + "/" + muid + "/" + id,
            type: "Delete",
            crossDomain: true,
          },
          {
            operation: "delete",
            vueScope: view,
          }
        )
        .then(function (response) {
          view.is_delete_email_button_disable = false;
          view.$utils.getForwardedEmail(view);
          view.$utils.getEmailDetails(view);
          view.fileuploadsuccesmsg = "";
          view.deletedialog = false;
          //view.ids = ''
          view.forwardemail_delete_msg = "Forwarded email deleted successfully";
          var element = document.getElementById("email__bodyelement");
          setTimeout(() => (view.forwardemail_delete_msg = ""), 10000);
          if (response == null) view.getHtmlData();
          else view.getHtmlData(response.efid);
          element.scrollIntoView();
          view.deletedmailmessage = response.message;
          //setTimeout(() => view.forwardemail_delete_msg = '', 10000)
        })
        .catch(function (e) {
          view.is_delete_email_button_disable = false;
          console.log(e);
        });
    },
    deleteattachment: function () {
      var view = this;
      view.showattachmentprogress = false;
      view.is_disable_attachment_button = true;
      //view.efid=''

      var endPoint = view.$url("UPLOAD_ATTACHMENTS");

      view.efid = "";

      var id = view.deletedattachmentid;
      view
        .$fetch(
          {
            url: endPoint + "/" + id,
            type: "Delete",
            crossDomain: true,
          },
          {
            operation: "delete",
            vueScope: view,
          }
        )
        .then(function (response) {
          view.deleteattachmessage = "Attachment deleted successfully";
          view.getAttachments();
          console.log(response);
          view.fileuploadsuccesmsg = "";
          view.deleteattachdialog = false;
          view.is_disable_attachment_button = false;
          //view.$utils.getEmailDetails(response)

          setTimeout(() => (view.deleteattachmessage = ""), 5000);
        })
        .catch(function (e) {
          view.is_disable_attachment_button = false;

          console.log(e);
        });
    },
    opendeleteattachconfirmbox: function (ids) {
      this.deleteattachdialog = true;
      this.deletedattachmentid = ids;
      this.deleteattachmessage = "";
      this.efid = "";
    },

    downloadattachment: function (ids, event) {
      event.preventDefault();
      var view = this;
      view.efid = "";
      var endPoint = view.$url("DOWNLOAD_ATTACHMENTS");
      window.location = endPoint + "/" + ids;
    },
    checkboxattfile(e, atchid) {
      this.checkedthis = false;
      this.showattachmentprogress = false;

      //e.target.checked
      if (e.target.checked) {
        if (this.checked_attachmentid.indexOf(e.target.value) == -1) {
          this.checked_attachmentid.push(e.target.value);
          this.file_atach_ids.push(atchid);
        }
      } else {
        this.checked_attachmentid.splice(
          this.checked_attachmentid.indexOf(e.target.value),
          1
        );
        this.file_atach_ids.splice(
          this.file_atach_ids.indexOf(e.target.value),
          1
        );
      }

      let chekcedstr = this.checked_attachmentid.join(",");
      let fileatidsstr = this.file_atach_ids.join(",");
      this.chekcedstr = chekcedstr;
      this.file_attach_str = fileatidsstr;
      console.log(this.chekcedstr);
    },
    opensendemail() {
      this.forwardemail_delete_msg = "";
      this.savedialog = true;
      this.saveonly = false;
      this.messages = "";
      this.efid = "";
    },
    opensaveemail() {
      this.forwardemail_delete_msg = "";
      this.savedialog = true;
      this.saveonly = true;
      this.efid = "";
      this.messages = "";
    },

    openPopUp: function (efid) {
      var view = this;
      view.efid = "";
      let efidversion = efid == "" ? "" : "/" + efid;

      window.open(
        view.$url("RENDER_HTML") + view.muid + efidversion,
        "emailbodypopup",
        "width=800,height=500"
      );
      window.focus();
    },
    openprocesshtmlPopUp: function (efid) {
      var view = this;
      view.efid = "";
      let efidversion = efid == "" ? "/original" : "/" + efid;

      window.open(
        view.$url("RENDER_PROCESSED_HTML") + view.muid + efidversion,
        "emailbodypopup",
        "width=800,height=500"
      );
      window.focus();
    },
    openpdfPopUp: function (efid) {
      var view = this;
      let efidversion = efid == "" ? "" : "/" + efid;
      view.efid = "";
      window.open(
        view.$url("RENDER_PDF") + view.muid + efidversion,
        "emailpdfpopup",
        "width=800,height=500"
      );
      window.focus();
    },
    //   openApcPopUp: function() {
    //     var view = this
    //     let indexName = this.$store.getters['Email/getIndexName']
    //     view.working = true
    //     view.$fetch({
    //         url: view.$url('BASE_URL') + 'apc-temp-process',
    //         type: 'POST',
    //         data: JSON.stringify({
    //             muid: view.muid,
    //             index_name: indexName,
    //         }),
    //         contentType: "application/json",
    //     },{
    //         operation: 'add',
    //         vueScope: view
    //     }).then(function(r) {
    //         view.working = false
    //         if ('doc' in r) {
    //             if ('deleted' in r['doc']) {
    //                 view.$store.dispatch('Email/setStatus', 'Used')
    //             }
    //         }
    //     }).catch(function(e) {
    //         console.log(e)
    //         view.working = false
    //     } )
    // },
    validate: function () {
      let errormessage = "";

      var mailformat =
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      if (this.forward_to.match(mailformat)) {
        this.is_valid_email = true;
        errormessage += "";
      } else {
        this.is_valid_email = false;
        errormessage += "Error:Invalid Email Id<br>";
      }
      if (this.cc.match(mailformat)) {
        this.is_valid_email_cc = true;
        errormessage += "";
      } else {
        this.is_valid_email_cc = true;
        errormessage += "Error:Invalid Email Id (CC:field)<br>";
      }

      if (this.forward_subject == "") {
        errormessage += "Error:Subject can not be left  blank<br>";
      }
      this.not_valid_message = errormessage;
    },
  },
  provide: {
        richtexteditor: [Toolbar,  PasteCleanup, FormatPainter,  HtmlEditor, Link,
      Image,
      Count,
      QuickToolbar,
      Table, Resize]
    },
};
</script>
<style>
  @import "https://cdn.syncfusion.com/ej2/28.2.3/material.css";
  @import "../../node_modules/@syncfusion/ej2-base/styles/material.css";
  @import "../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
  @import "../../node_modules/@syncfusion/ej2-lists/styles/material.css";
  @import "../../node_modules/@syncfusion/ej2-popups/styles/material.css";
  @import "../../node_modules/@syncfusion/ej2-buttons/styles/material.css";
  @import "../../node_modules/@syncfusion/ej2-navigations/styles/material.css";
  @import "../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css";
  @import "../../node_modules/@syncfusion/ej2-filemanager/styles/material.css";
  @import "../../node_modules/@syncfusion/ej2-richtexteditor/styles/material.css";

.v-toolbar__content {
  padding: 0px !important;
}

.e-rte-quick-popup .e-rte-quick-toolbar .e-rte-image-editor::before {
  content: '\\e81e';
}

.fluent .e-rte-quick-popup .e-rte-quick-toolbar .e-rte-image-editor::before,
.fluent-dark
  .e-rte-quick-popup
  .e-rte-quick-toolbar
  .e-rte-image-editor::before,
.fluent2 .e-rte-quick-popup .e-rte-quick-toolbar .e-rte-image-editor::before,
.fluent2-dark
  .e-rte-quick-popup
  .e-rte-quick-toolbar
  .e-rte-image-editor::before,
.fluent2-highcontrast
  .e-rte-quick-popup
  .e-rte-quick-toolbar
  .e-rte-image-editor::before,
.bootstrap5 .e-rte-quick-popup .e-rte-quick-toolbar .e-rte-image-editor::before,
.bootstrap5\.3
  .e-rte-quick-popup
  .e-rte-quick-toolbar
  .e-rte-image-editor::before,
.bootstrap5\.3-dark
  .e-rte-quick-popup
  .e-rte-quick-toolbar
  .e-rte-image-editor::before,
.bootstrap5-dark
  .e-rte-quick-popup
  .e-rte-quick-toolbar
  .e-rte-image-editor::before,
.tailwind .e-rte-quick-popup .e-rte-quick-toolbar .e-rte-image-editor::before,
.tailwind-dark
  .e-rte-quick-popup
  .e-rte-quick-toolbar
  .e-rte-image-editor::before,
.tailwind3 .e-rte-quick-popup .e-rte-quick-toolbar .e-rte-image-editor::before,
.tailwind3-dark
  .e-rte-quick-popup
  .e-rte-quick-toolbar
  .e-rte-image-editor::before,
.material3 .e-rte-quick-popup .e-rte-quick-toolbar .e-rte-image-editor::before,
.material3-dark
  .e-rte-quick-popup
  .e-rte-quick-toolbar
  .e-rte-image-editor::before {
  content: '\\e730';
}

.fabric .e-rte-quick-popup .e-rte-quick-toolbar .e-rte-image-editor::before,
.fabric-dark
  .e-rte-quick-popup
  .e-rte-quick-toolbar
  .e-rte-image-editor::before,
.highcontrast
  .e-rte-quick-popup
  .e-rte-quick-toolbar
  .e-rte-image-editor::before {
  content: '\\e97c';
}

.bootstrap4
  .e-rte-quick-popup
  .e-rte-quick-toolbar
  .e-rte-image-editor::before {
  content: '\\e78f';
}

</style>
<style lang="sass" scoped>
@import "./../assets/sass/email.sass"
</style>
